import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetailPage, serviceDetailHead } from "@/components/site/ServiceDetailPage";
import { serviceDetails } from "@/lib/service-details";

const service = serviceDetails.find((s) => s.slug === "catch-up-cleanup")!;

export const Route = createFileRoute("/services/catch-up-cleanup")({
  head: () => serviceDetailHead(service),
  component: () => <ServiceDetailPage service={service} />,
});
